import { isPlatformServer } from '@angular/common';
import { Inject, Injectable, NgZone, PLATFORM_ID } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { CookieService } from '@laurentgoudet/ngx-cookie';

@Injectable()
export class AdswapperTracking {
  private isEnabled = false;

  constructor(
    private ngZone: NgZone,
    @Inject(PLATFORM_ID) private platformId: Object,
    private route: ActivatedRoute,
    private cookie: CookieService,
  ) {}

  init() {
    if (this.isEnabled || isPlatformServer(this.platformId)) {
      return;
    }
    const hasAdswapperCookie = this.cookie.get('FROM_ADSWAPPER') === 'true';
    // Since the pixel is merely an image network request, I'm not confident it
    // has a mechanism to distinguish from other traffic. Other platforms like google
    // and facebook and other vendors have some sort of click id and have internal
    // logic in their JS.
    if (
      !hasAdswapperCookie &&
      this.route.snapshot.queryParams.utm_source === 'adswapper'
    ) {
      this.cookie.put('FROM_ADSWAPPER', 'true');
      this.isEnabled = true;
    }
    if (hasAdswapperCookie) {
      this.isEnabled = true;
    }
  }

  trackCustomEvent(): void {
    if (!this.isEnabled) {
      return;
    }
    this.ngZone.runOutsideAngular(() => {
      const trackingUrl =
        'https://adswapper.g2afse.com/success.jpg?offer_id=949&afstatus=1';

      // sendBeacon might not work for this type of pixel.
      // Based on other vendors, the request might return 200 but
      // they're not actually picked up. Creating an image tag
      // ensures it's as close as possible to the instructions
      const img = document.createElement('img');
      img.height = 1;
      img.width = 1;
      img.alt = '';
      img.src = trackingUrl;
    });
  }
}
